(() => {
  const DAY = 86400000;
  const fullDays = (date) => Math.max(0, Math.floor((Date.now() - new Date(date).getTime()) / DAY));
  const remaining = (start, low, high) => {
    const elapsed = fullDays(start);
    return { low: Math.max(0, low - elapsed), high: Math.max(0, high - elapsed) };
  };
  const formatDate = (date) => new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'Africa/Addis_Ababa'
  }).format(date);
  const estimateFor = (start, low, high) => {
    const base = new Date(start);
    if (Number.isNaN(base.getTime())) return '';
    const from = new Date(base.getTime() + (low * DAY));
    const to = new Date(base.getTime() + (high * DAY));
    return `የሚደርስበት ቀን / Expected arrival\n${formatDate(from)}–${formatDate(to)}`;
  };
  const preparingEstimateFor = (order) => {
    const shippedDates = (order.items || [])
      .map((item) => item.shippedAt)
      .filter(Boolean)
      .map((date) => new Date(date))
      .filter((date) => !Number.isNaN(date.getTime()));
    if (shippedDates.length) {
      const latestShipment = new Date(Math.max(...shippedDates.map((date) => date.getTime())));
      return estimateFor(latestShipment, 11, 17);
    }
    return estimateFor(order.createdAt, 15, 21);
  };

  function viewFor(order) {
    if (order.deliveredToCustomer === true || order.status === 'delivered') {
      return {
        step: 'delivered',
        title: 'ትዕዛዝዎ ለደንበኛው ደርሷል',
        copy: 'Your order has been delivered to the customer.',
        estimate: 'ትዕዛዙ በተሳካ ሁኔታ ተላልፏል።'
      };
    }

    if (order.receivedInNotion === true || order.status === 'received') {
      return {
        step: 'ethiopia',
        title: 'ትዕዛዝዎ አዲስ አበባ ደርሷል',
        copy: 'Your order is in Addis Ababa, ET. የShaba ቡድን ለአቅርቦት እያዘጋጀው ነው።',
        estimate: 'ለመረከብ ሲዘጋጅ እናሳውቅዎታለን።'
      };
    }

    if (order.fulfilledAt) {
      const range = remaining(order.fulfilledAt, 7, 10);
      if (range.high === 0) {
        return {
          step: 'fulfilled',
          title: 'ትዕዛዝዎ በመንገድ ላይ ነው',
          copy: 'የታሰበው ጊዜ አልፏል። ለአዲስ መረጃ Shabaን ያነጋግሩ።',
          estimate: 'The estimate has passed. Please contact Shaba for an update.',
          delayed: true
        };
      }
      return {
        step: 'fulfilled',
        title: 'ትዕዛዝዎ ወደ አዲስ አበባ እየመጣ ነው',
        copy: 'Your order is on the way to Addis Ababa, ET.',
        estimate: estimateFor(order.fulfilledAt, 7, 10)
      };
    }

    if (order.isPartiallyFulfilled === true || order.status === 'partially_fulfilled') {
      return {
        step: 'fulfilled',
        title: 'የትዕዛዝዎ አንድ ክፍል በመንገድ ላይ ነው',
        copy: 'Part of your order is on the way. The remaining items are still being prepared.',
        estimate: `${order.shippedQuantity || 0} of ${order.totalQuantity || 0} items shipped · Each product has its own estimate below`
      };
    }

    const range = remaining(order.createdAt, 15, 21);
    if (range.high === 0) {
      return {
        step: 'processing',
        title: 'ትዕዛዝዎን እያዘጋጀን ነው',
        copy: 'የታሰበው ጊዜ አልፏል። ለአዲስ መረጃ Shabaን ያነጋግሩ።',
        estimate: 'The estimate has passed. Please contact Shaba for an update.',
        delayed: true
      };
    }
    return {
      step: 'processing',
      title: 'ትዕዛዝዎን እያዘጋጀን ነው',
      copy: 'Your order is being prepared.',
      estimate: estimateFor(order.createdAt, 15, 21)
    };
  }

  document.querySelectorAll('[data-order-tracker]').forEach((root) => {
    const form = root.querySelector('.shaba-tracker-form');
    const result = root.querySelector('.shaba-tracker-result');
    const error = root.querySelector('.shaba-tracker-error');
    const submit = form.querySelector('button[type="submit"]');
    const again = root.querySelector('.shaba-tracker-again');

    const show = (order) => {
      const view = viewFor(order);
      root.querySelector('[data-tracker-order]').textContent = order.name || order.orderNumber;
      root.querySelector('[data-tracker-title]').textContent = view.title;
      root.querySelector('[data-tracker-copy]').textContent = view.copy;
      root.querySelector('[data-tracker-estimate]').textContent = view.estimate;
      const productList = root.querySelector('[data-tracker-products]');
      const statusLabels = {
        preparing: ['በዝግጅት ላይ', 'Preparing'],
        partial: ['በከፊል ተልኳል', 'Partially shipped'],
        shipped: ['በመንገድ ላይ', 'On the way'],
        addis: ['አዲስ አበባ ደርሷል', 'In Addis Ababa, ET'],
        delivered: ['ለደንበኛው ደርሷል', 'Delivered']
      };
      productList.replaceChildren();
      (order.items || []).forEach((item) => {
        const card = document.createElement('article');
        card.className = 'shaba-tracker-product';

        const media = document.createElement('div');
        media.className = 'shaba-tracker-product-media';
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.imageAlt || item.title || '';
          image.loading = 'lazy';
          media.appendChild(image);
        }

        const details = document.createElement('div');
        details.className = 'shaba-tracker-product-details';
        const title = document.createElement('h3');
        title.textContent = item.title || 'Product';
        const meta = document.createElement('p');
        const parts = [];
        if (item.variantTitle) parts.push(item.variantTitle);
        parts.push(`Qty ${item.quantity || 0}`);
        meta.textContent = parts.join(' · ');
        const itemEstimate = document.createElement('p');
        itemEstimate.className = 'shaba-tracker-product-estimate';
        if (item.status === 'preparing') {
          itemEstimate.textContent = preparingEstimateFor(order);
        } else if (item.status === 'shipped' || item.status === 'partial') {
          itemEstimate.textContent = estimateFor(item.shippedAt, 7, 10);
        }
        details.append(title, meta);
        if (itemEstimate.textContent) details.appendChild(itemEstimate);

        const badge = document.createElement('span');
        badge.className = `shaba-tracker-product-status is-${item.status || 'preparing'}`;
        const labels = statusLabels[item.status] || statusLabels.preparing;
        badge.textContent = `${labels[0]} · ${labels[1]}`;

        card.append(media, details, badge);
        productList.appendChild(card);
      });
      root.querySelector('.shaba-tracker-message').classList.toggle('is-delayed', Boolean(view.delayed));
      const orderSteps = ['ordered', 'processing', 'fulfilled', 'ethiopia', 'delivered'];
      const active = orderSteps.indexOf(view.step);
      root.querySelectorAll('[data-step]').forEach((step, i) => step.classList.toggle('is-complete', i <= active));
      form.hidden = true;
      result.hidden = false;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      error.hidden = true;
      const orderNumber = form.order.value.trim().replace(/^#/, '');
      const phone = form.phone.value.replace(/[^\d+]/g, '');
      if (!orderNumber || phone.replace(/\D/g, '').length < 9) {
        error.textContent = 'የትዕዛዝ ቁጥርና ትክክለኛ ስልክ ቁጥር ያስገቡ።';
        error.hidden = false;
        return;
      }
      if (!root.dataset.endpoint) {
        error.textContent = 'የትዕዛዝ መከታተያው በዝግጅት ላይ ነው። Please contact Shaba for an update.';
        error.hidden = false;
        return;
      }
      submit.disabled = true;
      submit.classList.add('is-loading');
      try {
        const response = await fetch(root.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ orderNumber, phone })
        });
        const payload = await response.json();
        if (!response.ok || !payload.order) {
          if (response.status === 404) {
            error.textContent = 'ትዕዛዙ አልተገኘም። የትዕዛዝ ቁጥሩንና ስልክ ቁጥሩን ያረጋግጡ።';
          } else if (response.status === 429) {
            error.textContent = 'ብዙ ጊዜ ሞክረዋል። ትንሽ ቆይተው እንደገና ይሞክሩ።';
          } else {
            const code = payload.code ? ` (${payload.code})` : '';
            error.textContent = `የመከታተያ ግንኙነቱ ለጊዜው አልሰራም። እንደገና ይሞክሩ።${code}`;
          }
          error.hidden = false;
          return;
        }
        show(payload.order);
      } catch (e) {
        console.error('Shaba tracker failed', e);
        error.textContent = 'የመከታተያ ገጹ ላይ ችግር ተፈጥሯል። ገጹን አድሰው እንደገና ይሞክሩ።';
        error.hidden = false;
      } finally {
        submit.disabled = false;
        submit.classList.remove('is-loading');
      }
    });

    again.addEventListener('click', () => {
      result.hidden = true;
      form.hidden = false;
      form.order.focus();
    });
  });
})();
